<form [formGroup]="form">
  <div class="card form-card">
    <h3 class="card-header" i18n="@@components.api_keys.api_key">API Key</h3>
    <div class="card-body">
      <p>{{ note }}</p>
      <div class="row max-form-width">
        <div class="col-sm-12">
          <input-field formControlName="name" i18n-label="@@components.admin_api_keys.key_name" label="Key Name"></input-field>
        </div>
        <div class="col-sm-12">
          <datepicker-field formControlName="expires_at" i18n-label="@@common.expires_at" label="Expires at" placement="bottom" [minDate]="minDate"></datepicker-field>
        </div>
      </div>
    </div>
  </div>
</form>
